"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.playablePropsSDKFactory = void 0;
const validations_1 = require("../validations");
const corvidEvents_1 = require("../corvidEvents");
const _playablePropsSDKFactory = api => {
    return {
        get isPlaying() {
            return api.props.isPlaying;
        },
        play() {
            api.compRef.play();
            return api.getSdkInstance();
        },
        pause() {
            api.compRef.pause();
            return api.getSdkInstance();
        },
        onPlay: handler => (0, corvidEvents_1.registerCorvidEvent)('onPlay', api, handler),
        onPause: handler => (0, corvidEvents_1.registerCorvidEvent)('onPause', api, handler),
        next() {
            return new Promise((resolve, reject) => {
                reject('sdk method not implemented');
            });
        },
        previous() {
            return new Promise((resolve, reject) => {
                reject('sdk method not implemented');
            });
        },
    };
};
exports.playablePropsSDKFactory = (0, validations_1.withValidation)(_playablePropsSDKFactory, {
    type: ['object'],
    properties: {},
});
//# sourceMappingURL=playablePropsSDKFactory.js.map